import { render, staticRenderFns } from "./MembeEventHistoryDetails.vue?vue&type=template&id=3ca3f967&"
import script from "./MembeEventHistoryDetails.vue?vue&type=script&lang=js&"
export * from "./MembeEventHistoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports